/**
 * Created by jv on 2019-09-09 (12:33).
 */
const log = require("Sources/utils/logger")();

import utils from "Sources/utils/utils";
import AppError from "Sources/models/app-error";
import HistoryController from "Sources/controllers/history-controller";
import Analytics from "Sources/misc/analytics";

class GamePageController
{
  constructor(options)
  {
    if(utils.isNull(options) || !utils.isArray(options.gameViews) || options.gameViews.length === 0)
    {
      throw new AppError({ exception: new Error("GamePageController needs valid options object with at least 1 gameView") });
    }

    this.gameViews = options.gameViews;
    this.defaultView = options.defaultView ? options.defaultView : this.gameViews[0];

    this.basePath = options.basePath ? options.basePath : "";

    this.onBeforePageChange = options.onBeforePageChange;
    this.onContentShow = options.onContentShow;

    this.initialPage = options.initialPage;

    this.currentGameView = null;
  }

  init()
  {
    this._setInitialPage();
    this._setUpEventListeners();
  }

  changePage(gameView, replaceState)
  {
    // NOTE - browser navigation should be disabled, we don't want users to use the back/forward buttons
    replaceState = true;

    if(utils.isNull(gameView)) gameView = {};

    log.info("Trying to change page to gameView [%s]\nreplaceState: %s", gameView.key, replaceState);

    if(utils.isFunction(this.onBeforePageChange))
    {
      let allowContinue = this.onBeforePageChange(gameView);

      if(!allowContinue)
      {
        return;
      }
    }

    let valid = this.validateView(gameView.key);

    log.info("GameView '%s' valid ? %s", gameView.key, valid);

    if(valid)
    {
      let url = `${this.basePath}/${gameView.path}`;

      if(replaceState)
      {
        HistoryController.replaceState({
          contentId: gameView.key
        }, null, url);
      }
      else
      {
        HistoryController.pushState({
          contentId: gameView.key
        }, null, url);
      }

      Analytics.setPage(url);

      this.showContent(gameView);
    }
  }

  showContent(gameView)
  {
    if(utils.isNull(gameView)) return;

    let isValid = this.validateView(gameView.key);

    if(!isValid)
    {
      return;
    }

    for(let i = 0; i < this.gameViews.length; i++)
    {
      this.gameViews[i].hide();
    }

    if(!gameView.hasRendered)
    {
      gameView.render();
    }

    this.currentGameView = gameView;

    if(utils.isFunction(this.onContentShow))
    {
      this.onContentShow.call(this, gameView);
    }

    if(gameView.key === "session-join")
    {
      $("footer").removeClass("marketing").addClass("marketing");
      $("footer div.container").show();
    }
    else
    {
      $("footer").removeClass("marketing");
      $("footer div.container").hide();
    }
  }

  validatePath(path)
  {
    if(utils.isNotNull(path))
    {
      path = path.replace(this.basePath + "/", "");

      // TODO validate path
      return true;
    }

    return false;
  }

  validateView(gameViewKey)
  {
    if(utils.isNotNull(gameViewKey))
    {
      for(let i = 0; i < this.gameViews.length; i++)
      {
        if(this.gameViews[i].key === gameViewKey)
        {
          return true;
        }
      }
    }

    return false;
  }

  _setInitialPage()
  {
    let pathName = this.initialPage || utils.getUrlPath();

    let isValid = this.validatePath(pathName);

    log.info("Path '%s' is %s", pathName, isValid ? "valid" : "not valid");

    if(isValid)
    {
      let foundGameView = null;

      for(let i = 0; i < this.gameViews.length; i++)
      {
        if(pathName.includes(this.gameViews[i].path))
        {
          foundGameView = this.gameViews[i];
          break;
        }
      }

      if(utils.isNotNull(foundGameView))
      {
        if(utils.isNull(this.initialPage) || this.initialPage === utils.getUrlPath())
        {
          this.showContent(foundGameView);
        }
        else
        {
          this.changePage(foundGameView, true);
        }
      }
      else
      {
        this.changePage(this.defaultView, true);
      }
    }
    else
    {
      this.changePage(this.defaultView, true);
    }
  }

  _setUpEventListeners()
  {
    $(window).on("popstate", (event) =>
    {
      log.info(event);
      log.info("On popstate - state: %o", event.originalEvent.state);

      let contentId;
      let valid = false;

      if(utils.isNotNull(event.originalEvent.state))
      {
        valid = this.validateView(event.originalEvent.state.contentId);
        contentId = event.originalEvent.state.contentId;
      }

      if(valid)
      {
        this.showContent(contentId);
      }
      else
      {
        this.changePage(this.defaultView, true);
      }
    });
  }
}

module.exports = GamePageController;



// WEBPACK FOOTER //
// ./app/js/controllers/game-page-controller.js